module.exports = __webpack_public_path__ + "media/images/flags/64/Papua-New-Guinea-be55cf3b23eca0365ad5270e083704d4.png";